import { AUDIT_ACTION_GROUP_TYPES, type AuditActionGroupType } from '@/types/auditApiTypes';

const AUDIT_PATH = '/api/audit';

const PASSPORT_DOCUMENT_PATTERN = /^\/api\/documents\/passport(?:\/|$)/;
const CLIENT_DOCUMENT_PATTERN = /^\/api\/documents(?:\/|$)/;

const MEDIA_HANDLING_PATTERNS = [
  /^\/api\/media(?:\/|$)/,
  /^\/api\/media-attachments(?:\/|$)/,
  /^\/api\/gallery(?:\/|$)/,
  /^\/api\/folders(?:\/|$)/,
  /^\/api\/storage\/presigned-url(?:\/|$|\?)/,
] as const;

export function extractApiPathname(url: string): string {
  if (url.startsWith('http://') || url.startsWith('https://')) {
    try {
      return new URL(url).pathname;
    } catch {
      return url.split('?')[0] ?? url;
    }
  }

  return url.split('?')[0] ?? url;
}

export function isAuditEndpoint(pathname: string): boolean {
  return pathname === AUDIT_PATH || pathname.startsWith(`${AUDIT_PATH}/`);
}

export function resolveAuditActionGroupType(url: string): AuditActionGroupType | null {
  const pathname = extractApiPathname(url);

  if (isAuditEndpoint(pathname)) {
    return null;
  }

  if (PASSPORT_DOCUMENT_PATTERN.test(pathname)) {
    return AUDIT_ACTION_GROUP_TYPES.PASSPORT_CREATION;
  }

  if (CLIENT_DOCUMENT_PATTERN.test(pathname)) {
    return AUDIT_ACTION_GROUP_TYPES.CLIENT_DOCUMENT_CREATION;
  }

  if (MEDIA_HANDLING_PATTERNS.some((pattern) => pattern.test(pathname))) {
    return AUDIT_ACTION_GROUP_TYPES.MEDIA_HANDLING;
  }

  return null;
}
